import { get, post, put } from '@/util/request'

let prefix = '/api'

const isDev = process.env.NODE_ENV === "development"
if(!isDev) {
  prefix = location.origin + '/api'
}

/** 注册接口 */
export function registerApi(...args) {
  return post(`${prefix}/poros-authcenter/register/save`, ...args)
}
/** 注册：发送验证码 */
export function registerSendCodeApi(...args) {
  return get(`${prefix}/poros-authcenter/register/sendCode`, ...args)
}
/** 用户名是否已经存在 */
export function isExistApi(...args) {
  return get(`${prefix}/poros-authcenter/register/isExist`, ...args)
}
/** 登录接口 */
export function loginApi(...args) {
  return post(`${prefix}/poros-authcenter/login`, ...args)
}
/** 找回密码：发送邮件 */
export function resetSendCodeApi(...args) {
  return post(`${prefix}/poros-authcenter/reset/sendCode`, ...args)
}
/** 重置密码页：根据token获取用户信息 */
export function getResetInfoApi(...args) {
  return get(`${prefix}/poros-authcenter/reset/data`, ...args)
}
/** 通过邮件重置密码 */
export function resetByEmailApi(...args) {
  return post(`${prefix}/poros-authcenter/reset/email`, ...args)
}
/** 通过token重置密码 */
export function resetByTokenApi(...args) {
  return put(`${prefix}/poros-authcenter/reset/user`, ...args)
}
/** 通过手机号重置密码 */
export function resetByMobileApi(...args) {
  return post(`${prefix}/poros-authcenter/reset/mobile`, ...args)
}
/** 查询当前用户信息 */
export function getUserMessageApi() {
  return get(`${prefix}/poros-authcenter/user/message`)
}
/** 登出接口 */
export function logoutApi() {
  return get(`${prefix}/poros-authcenter/user/logout`)
}
/** 根据用户名或手机号获取密钥 */
export function getSecretKeyApi(username, ...args) {
  return get(`${prefix}/poros-authcenter/secret/${username}`, ...args)
}
/** 修改密码 */
export function updatePasswordApi(...args) {
  return put(`${prefix}/poros-authcenter/reset/userAuth`, ...args)
}
/** 查询当前用户有权限访问的系统列表 */
export function getPermissionApi() {
  return get(`${prefix}/poros-permission/sys/uid`)
}
/** 获取ad域token */
export const getAdToeknUrl = `${prefix}/poros-authcenter/oauth/ad`

/*------- 登录 ------*/
// 生成密钥接口
export const getKey = (parameter)=> {
  return get(`${prefix}/poros-authcenter/secret/${parameter.username}`);
}
// 登录
export const login = (parameter) => {
  return post(`${prefix}/poros-authcenter/login`, parameter);
}

/** 登录回调 */
// 登录
export const pushLoginInfo = () => {
  return post(`${prefix}/system-service/login`,{});
}
// 获取图片验证码
export const getImageVeryCode = () => {
  return get(`${prefix}/poros-permission/code/getCode`)
}

// 获取短信验证码(登录)
export const getMobileVeryCode = (params) => {
  return post(`/api/poros-authcenter/verification/getLoginSmsCode`, params)
}

// 获取用户信息
export function getCurUser () {
  return get(`${prefix}/poros-permission/secStaff/getCurUser`);
}

// 获取系统id
export function getSystemId () {
  return get(`${prefix}/geek-system/system/code/geek`);
}

/*------- 注册 ------*/
// 注册
// export const register = function () {
//   return post(`${prefix}/poros-permission/userReg/register`, ...arguments)
// };
export const register = function () {
  return post(`${prefix}/system-service/customerAudit/add`, ...arguments)
};
// 获取租户信息
export const prefectInfo = (params) => get(`${prefix}/poros-permission/tenantInfo/getTenantInfo`, {params})
// 获取短信验证码（完善资料）
export const getMobileVeryCodeComplete = (params) => {
  return post(`${prefix}/poros-permission/secStaff/mobile/verifyCode`, params)
}
// 获取短信验证码（注册）
export const getMobileVeryCodeRegiest = (params) => {
  return post(`${prefix}/poros-permission/code/sms/verify`, params)
}
// export const getMobileVeryCodeRegiest = (params) => {
//   return post(`${prefix}/poros-permission/userReg/mobile/verifyCode`, params)
// }

//注册验证码验证
export const postMobileCheckSsmVerify = (params) => {
  return post(`${prefix}/poros-permission/code/check/ssmVerify`, params)
}




//获取二维码
export function getLoginCode () {
  return get(`${prefix}/poros-authcenter/qrcode/getCode`);
}

//获取登陆状态
export const getLogintatus = (verify)=> {
  return get(`${prefix}/poros-authcenter/qrcode/getLogintatus/${verify}`);
}

